import { Link as RouterLink } from 'react-router-dom';
import {
    Breadcrumbs,
    Grid,
    IconButton,
    Link,
    Toolbar,
    Tooltip,
    Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack } from '@material-ui/icons';
import { useEffect, useState, Fragment } from 'react';
import { Auth } from 'aws-amplify';
import TankTemplatesManagement from './Components/TankTemplatesManagement';
import { host } from "../../data";
import BranchesNavigationButton from "../Components/BranchNavigationButton";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    indented: {
        marginLeft: theme.spacing(10),
    },
    grow: {
        flexGrow: 1,
    },
    content: {
        padding: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    formControlLabel: {
        marginLeft: theme.spacing(2),
    },
    rootpaper: {
        width: 1000,
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        overflowX: "auto"
    },
    table: {
        width: 1000
    },
}));

export default function OrgTemplates({ orgInfo }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [templates, setTemplates] = useState([]);
    const [branches, setBranches] = useState([]);

    useEffect(() => {
        fetchBranchData();
    }, [orgInfo]);

    function fetchBranchData() {
        Auth.currentAuthenticatedUser()
            .then(data => {
                var requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': data.signInUserSession.idToken.jwtToken
                    }
                };

                fetch(host + '/orgs/' + orgInfo.orgId
                    + '/branches', requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        // If no branch exists, send the user to the branch creation page.
                        setBranches(
                            data.data.branchesList
                        );
                    }).catch((error) => {
                        console.log(error);
                    });
            });
    }


    function handleSetTemplates(data_in) {
        var lTemplates = data_in;
        setTemplates(lTemplates);
    }

    useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(data => {
                var requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': data.signInUserSession.idToken.jwtToken
                    },
                };

                fetch(host + '/orgs/' + orgInfo.orgId + '/templates/', requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        handleSetTemplates(data.templatesList);
                    }).catch((error) => {
                        console.log(error)
                    })
            });
    }, [orgInfo]);

    return (
        <Grid container
            direction='column'
            justify='flex-start'
            alignItems='stretch'
            className={classes.content}>
            <Grid item xs>
                <Toolbar>
                    <Tooltip title={t("goHome")}>
                        <IconButton color='primary'
                            component={RouterLink}
                            to={'/'}>
                            <ArrowBack />
                        </IconButton>
                    </Tooltip>
                    <Breadcrumbs>
                        <Link variant='h5'
                            component={RouterLink}
                            to={'/'}>
                            {t("settings")}
                        </Link>
                        <Typography variant="h5">
                            {t("templates")}
                        </Typography>
                    </Breadcrumbs>
                    <div className={classes.content} />
                    <BranchesNavigationButton text={t("branches_caps")} orgInfo={orgInfo} branchesList={branches} />
                </Toolbar>
            </Grid>
            <Grid item xs>
                <Fragment>
                    <TankTemplatesManagement
                        orgInfo={orgInfo}
                        templates={templates}
                        setTemplates={handleSetTemplates}
                    />
                </Fragment>
            </Grid>
        </Grid>
    )
}